import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "../lib/api";
import { loginWithMicrosoftPopup, msalEnabled } from "../lib/msal";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  const finishLogin = (data) => {
    setUser(data.user);
  };

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    finishLogin(r.data);
  };

  const loginMicrosoft = async () => {
    const accessToken = await loginWithMicrosoftPopup();
    const r = await api.post("/auth/microsoft", { access_token: accessToken });
    finishLogin(r.data);
  };

  const logout = useCallback(() => {
    api.post("/auth/logout").catch(() => {});
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, login, loginMicrosoft, logout, msalEnabled }}>
      {children}
    </AuthContext.Provider>
  );
}
